import { Injectable } from '@angular/core';
import { Category } from '@models/masters';
import { DateLike, calculateAge } from '@utils/isAdult';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  public getCategory(birthDate: DateLike): Category {
    const age = calculateAge(birthDate);

    if (age >= 50) {
      return Category.MASTER50;
    } else if (age >= 45) {
      return Category.MASTER;
    } else if (age >= 18) {
      return Category.SENIOR;
    } else if (age >= 16) {
      return Category.JUVENIL;
    } else if (age >= 14) {
      return Category.CADETE;
    } else if (age >= 12) {
      return Category.INFANTIL;
    } else if (age >= 10) {
      return Category.ALEVIN;
    } else {
      return Category.BENJAMIN;
    }
  }

  convertImageUrlToBlob(dataURL: string): Blob {
    const byteString = atob(dataURL.split(',')[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([uint8Array], { type: 'image/png' });
  }
}
